import { render, staticRenderFns } from "./subjects-facets.vue?vue&type=template&id=4f3a0cbb&scoped=true&"
import script from "./subjects-facets.ts?vue&type=script&lang=ts&"
export * from "./subjects-facets.ts?vue&type=script&lang=ts&"
import style0 from "./subjects-facets.scss?vue&type=style&index=0&id=4f3a0cbb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3a0cbb",
  null
  
)

export default component.exports